// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__1KKQ_","ThumbZoom":"ChapterPlayer_ThumbZoom__28al0"};